import { render, staticRenderFns } from "./CriticalProducts.vue?vue&type=template&id=272b81a0&"
import script from "./CriticalProducts.vue?vue&type=script&lang=js&"
export * from "./CriticalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports